import { render, staticRenderFns } from "./RestaurantCard.vue?vue&type=template&id=c28ee206&lang=pug&"
import script from "./RestaurantCard.vue?vue&type=script&lang=js&"
export * from "./RestaurantCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports